import { Layout } from "Components/Layout/Layout";
import React from "react";
import { lazyLoader } from "Service/loader";

const WarrantyCreate = lazyLoader(
  () => import("Containers/Warranty/WarrantyForm/WarrantyForm")
);

export const WarrantyCreateForm = () => {
  return (
    <Layout>
      <WarrantyCreate type="CREATE" />
    </Layout>
  );
};
